export default __webpack_public_path__ + "static/media/skirmishers_dirk.3d61b999.jpg";